import React from "react";

const H3 = (props) => {
  const { children, color, classe } = props;

  return (
    <h3
      className={`
          font-nunito
            text-base
            font-bold
            leading-snug
            text-secondary
            ${classe}
        `}
    >
      {children}
    </h3>
  );
};

export default H3;
